module.exports = __webpack_public_path__ + "static/media/train.a0de0b56.svg";